

















































































import { List, ListItem, StepperInput } from "@goodless/components"
import {Checkout, OrderData, OrderType } from "@goodless/structures";
import { Formatter } from "@goodless/utilities";
import { NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
    components: {
        List,
        ListItem,
        StepperInput
    },
})
export default class CartFooter extends Mixins(NavigationMixin) {
    @Prop({ required: true })
    checkout: Checkout | OrderData

    @Prop({ default: true })
    showPrices: boolean

    @Prop({ default: true })
    showVat: boolean

    get isDelivery() {
        return this.checkout.type === OrderType.Delivery
    }

    get prices() {
        return this.checkout instanceof OrderData ? this.checkout.prices : this.checkout.calculatedPrices
    }

    formatPrice(price: number) {
        return Formatter.price(price)
    }

    get kgSavedFormatted() {
        return ('' + this.kgSaved).replace(".", ",")
    }

    get kgSaved() {
        return this.checkout.cart.kgSaved
    }
}
